module.exports = __webpack_public_path__ + "static/media/hryvnia.e62d2f6b.svg";